import { paymentsApi, PromoCodeValidation, CreateOrderData, PaymentOrder } from './api/paymentsApi';

class PaymentsService {
  // Validate promo code
  async validatePromoCode(code: string, amount: number): Promise<PromoCodeValidation | null> {
    try {
      const response = await paymentsApi.validatePromoCode(code, amount);
      if (response && response.data) {
        return response.data;
      }
      return null;
    } catch (error: any) {
      console.error('Error validating promo code:', error);
      throw new Error(error.response?.data?.message || 'Failed to validate promo code');
    }
  }

  // Create order
  async createOrder(data: CreateOrderData): Promise<PaymentOrder> {
    try {
      const response = await paymentsApi.createOrder(data);
      if (response && response.data && response.data.order) {
        return response.data.order;
      }
      throw new Error('Invalid response from API');
    } catch (error: any) {
      console.error('Error creating order:', error);
      throw new Error(error.response?.data?.message || 'Failed to create order');
    }
  }
}

export const paymentsService = new PaymentsService();


